/**
 * Enum representing different variants.
 * Used to specify various types or sizes of an element.
 *
 * @enum {string}
 * @readonly
 * @property {string} PRIMARY - Represents the primary variant.
 * @property {string} SECONDARY - Represents the secondary variant.
 * @property {string} TERTIARY - Represents the tertiary variant.
 * @property {string} QUATERNARY - Represents the quaternary variant.
 * @property {string} SMALL - Represents a small-sized variant.
 */

export const Variants = Object.freeze({
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  QUATERNARY: "quaternary",
  SMALL: "small",
});
